import React, { PureComponent } from 'react';
import axios from 'axios';
import { Carousel } from 'react-responsive-carousel';
import ReactDOM from 'react-dom';

import { urls } from '../../../services/urls';
import { T } from '../../../../../common/locale/translate';

class BlogRelatedOffers extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hotels: []
    };
  }

  componentDidMount() {
    axios({
      method: 'get',
      url: urls['blog_related_offers'],
      headers: {
        'Content-Type': 'application/json'
      },
      params: {
        search_params: this.props.search_params
      }
    }).then(response => {
      /*eslint-disable */
      new Blazy({ selector: '.b-lazy' });

      this.setState({ hotels: response.data });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.hotels.length === 0 && this.state.hotels.length > 0) {
      const blogContent = document.getElementById('blog-content');
      if (blogContent) {
        const h2Elements = blogContent.getElementsByTagName('h2');
        for (let i = 1; i < h2Elements.length; i++) {
          const container = document.createElement('div');
          h2Elements[i].parentNode.insertBefore(container, h2Elements[i]);
          ReactDOM.render(
            <section className="related-offers-section content-section">
              <div className="blog-related-offers">
                {this.getHotelsForIndex(i).map((hotel, key) =>
                  this.offersComponent(hotel, key)
                )}
              </div>
            </section>,
            container
          );
        }
      }
    }
  }

  getHotelsForIndex = h2Index => {
    const startIndex = (h2Index - 1) * 2;
    const endIndex = startIndex + 2;

    if (startIndex >= this.state.hotels.length) {
      return [];
    }

    return this.state.hotels.slice(
      startIndex,
      Math.min(endIndex, this.state.hotels.length)
    );
  };

  render() {
    return (
      this.state.hotels.length > 0 && (
        <section className="related-offers-section">
          <div className="carousel">
            <Carousel
              className="curiosity-slider"
              showArrows={false}
              showThumbs={false}
              emulateTouch={false}
              showIndicators={true}
              autoPlay={true}
              showStatus={false}
              infiniteLoop={true}
              axis="horizontal"
              stopOnHover={false}
              transitionTime={1000}
              interval={20000}
            >
              {this.state.hotels.slice(-4).map((hotel, key) => (
                <div className="mobile-blog-related-offers" key={key}>
                  {this.offersComponent(hotel, '')}
                </div>
              ))}
            </Carousel>
          </div>
          <div className="blog-related-offers">
            {this.state.hotels
              .slice(-4)
              .map((hotel, key) => this.offersComponent(hotel, key))}
          </div>
          <div className="button-wrapper">
            <a
              href={`${window.location.protocol}//${
                window.location.host
              }/offers?${this.props.search_url}`}
              title={T('see_more_offers')}
            >
              <span>{T('see_more_offers')}</span>
            </a>
          </div>
        </section>
      )
    );
  }

  offersComponent = (hotel, key) => (
    <a
      href={hotel.link_to_offer}
      className="offer-item"
      title={`${hotel.offer_type_name_singular}: ${hotel.subject.name}`}
      key={key}
    >
      <figure>
        <div className="offer-categories">
          <img
            className="b-lazy"
            data-src={
              hotel.subject.thumbnail
                ? hotel.subject.thumbnail
                : hotel.subject.image_urls
                  ? hotel.subject.image_urls[0]
                  : '/img/placeholder/offer-250x240.png'
            }
            alt={hotel.subject.name}
          />
          <div className="offer-categories-wrapper">
            {hotel.is_allinclusive && (
              <span className="offer-category all-inclusive">
                {T('all_inclusive')}
              </span>
            )}
            {hotel.is_firstminute && (
              <span className="offer-category first-minute">
                {T('first_minute')}
              </span>
            )}
            {hotel.is_lastminute && (
              <span className="offer-category last-minute">
                {T('last_minute')}
              </span>
            )}
            <span
              className={`offer-category ${hotel.offer_type.toUpperCase()}`}
            >
              {hotel.offer_type_name_singular}
            </span>
          </div>
        </div>
        <figcaption className="offer-description">
          <span className="category">
            {hotel.subject.country_name && `${hotel.subject.country_name}, `}
            {hotel.subject.region_name}
          </span>
          <h4 className="title">{hotel.subject.name}</h4>
          {hotel.subject.rating && (
            <span className={`stars stars-${hotel.rating_class}`} />
          )}
          <div className="rating-price">
            <p className="price">
              {T('price_from')} <strong> {parseInt(hotel.price_pln)} </strong>
              <span> {T('currency_pln')} </span> {T('per_person')}
            </p>
          </div>
        </figcaption>
      </figure>
    </a>
  );
}

export default BlogRelatedOffers;



// WEBPACK FOOTER //
// ./app/javascript/pages/blog/components/blog_related_offers.jsx